import Checkout from "components/Checkout";

const PrivateLimitedCompanyPage = () => (
  <Checkout companyType="Private Company" self />
);

export default PrivateLimitedCompanyPage;
